require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-want-to-know-the-best-way-to-learn-ruby-on-rails-we-ve-got-the-answer-here.json") })
        }
      }, "path---blog-want-to-know-the-best-way-to-learn-ruby-on-rails-we-ve-got-the-answer-here");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-want-to-know-the-best-way-to-learn-ruby-on-rails-we-ve-got-the-answer-here!./.cache/json/blog-want-to-know-the-best-way-to-learn-ruby-on-rails-we-ve-got-the-answer-here.json
// module id = 1144
// module chunks = 231608221292675